import { useQuery } from "react-query";
import axios from "axios";
import { useEffect, useState } from "react";
import "./home.scss";
import { BrandButton, BrandButtonWhite } from "../components/form/buttons";
import { useNavigate } from "react-router-dom";
import Loader from "../components/loader";
import LoadError from "../components/error";
import { ApiEndpoint, imagesUrl } from "../components/utils";
import { pageIds } from "../components/utils";
import NetworkError from "../components/networkError";

interface PageResponse {
  headerTitle?: string;
  welcomeMessage?: any;
  standardHeadline?: string;
  extendedHeadline?: string;
  standardDescription?: any;
  extendedDescription?: any;
  footerDescription?: any;
}

interface WelcomeMessage {
  part1: string | undefined;
  part2: string | undefined;
}

const Home = () => {
  const [data, setdata] = useState<PageResponse | null>();
  const navigate = useNavigate();
  const [welcomeMessage, setWelcomeMessage] = useState<WelcomeMessage>();
  const [networkError, setNetworkError] = useState(false);

  const { isLoading, error } = useQuery("welecomePageData", async () => {
    try {
      const resp = await axios.get(
        ApiEndpoint +
          "wp-json/firstchoiceprep/v1/getPageText?slug=" +
          pageIds.homepage
      );
      setdata(resp.data as PageResponse);
    } catch (e) {
      setNetworkError(true);
    }
  });

  useEffect(() => {
    if (!data) return;
    const tempText = data?.welcomeMessage.split("<p>[EMBED]</p>");
    setWelcomeMessage({ part1: tempText[0], part2: tempText[1] });
  }, [data]);

  if (networkError) return <NetworkError open={true} />;

  if (isLoading || !welcomeMessage?.part1 || !welcomeMessage?.part2)
    return <Loader />;
  if (error) return <LoadError />;
  return (
    <div className="homePage">
      <div className="pageHeader">
        <h1>{data?.headerTitle}</h1>
      </div>
      <div className="pageContent">
        {/* deepcode ignore DOMXSS: trusted html */}
        <div dangerouslySetInnerHTML={{ __html: welcomeMessage?.part1 }} />
        {/* <div className="registerCallout">
          <BrandButton
            variant="contained"
            onClick={() => navigate("/login", { replace: true })}
          >
            REGISTER / LOGIN
          </BrandButton>
        </div> */}
      </div>
      <div className="homeStats">
        <div className="stat">
          <p>
            32/<span>1420</span>
          </p>
          <p>Your baseline scores on the SAT and ACT</p>
        </div>
        <div className="stat">
          <p>
            SAT | <span>ACT</span>
          </p>
          <p>Which of those tests you're better suited to</p>
        </div>
        <div className="stat">
          <p>
            93<span>%</span>
          </p>
          <p>
            Your strengths and weaknesses in all content areas on both tests
          </p>
        </div>
      </div>
      <div className="embedCallout">
        <div className="embedCalloutContent">
          <div className="leftColumn">
            <p>TAKE THE TEST</p>
          </div>
          <div
            className="rightColumn"
            style={{ backgroundImage: `url('${imagesUrl}/embedBGsmall.svg')` }}
          >
            <div className="box">
              <div>
                <BrandButton
                  variant="contained"
                  onClick={() => navigate("/register", { replace: false })}
                >
                  REGISTER
                </BrandButton>
              </div>
              <p>
                <img src={`${imagesUrl}upArrow.svg`} alt="UpArrow" />
              </p>
              <p>
                Never taken the test? Click the <span>REGISTER</span> button
                above
              </p>
            </div>
            <div className="box">
              <div>
                <BrandButtonWhite
                  variant="contained"
                  onClick={() => navigate("/login", { replace: false })}
                  data-testid="loginBtn"
                >
                  LOGIN
                </BrandButtonWhite>
              </div>
              <p>
                <img src={`${imagesUrl}upArrow.svg`} alt="UpArrow" />
              </p>
              <p>
                If you've already registered, click the <span>LOGIN</span>{" "}
                button above
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="pageContent">
        <div dangerouslySetInnerHTML={{ __html: welcomeMessage?.part2 }} />
        <div
          className="homeFooter"
          dangerouslySetInnerHTML={{ __html: data?.footerDescription }}
        />
      </div>
    </div>
  );
};

export default Home;
